import api from '@/libs/axios'

export default {
  async getList(params) {
    let response = await api.get('/earns/admin/nft-chipset-imgs', { params })
    return response
  },
  async get(params) {
    let response = await api.get('/earns/admin/nft-chipset-imgs/detail', {
      params,
    })
    return response.data.data || null
  },
  async create(payload) {
    let response = await api.post('/earns/admin/nft-chipset-imgs', payload)
    return response
  },
  async update(payload) {
    let response = await api.put('/earns/admin/nft-chipset-imgs', payload)
    return response
  },
  async delete(payload) {
    let response = await api.delete('/earns/admin/nft-chipset-imgs', { data: payload })
    return response
  },
}
